import React from 'react';
import Tippy from '@tippyjs/react';
import amex from '@/resources/paymentIcons/amex.svg';
import visa from '@/resources/paymentIcons/visa.svg';
import discover from '@/resources/paymentIcons/discover.svg';
import mastercard from '@/resources/paymentIcons/mastercard.svg';
import debit from '@/resources/paymentIcons/debit.svg';
import payPal from '@/resources/paymentIcons/PayPal.svg';
import venmo from '@/resources/paymentIcons/venmo.svg';
import applePay from '@/resources/paymentIcons/applePay.svg';

import '@/app/pages/companyProfile/addedBy/CompanyNewEnhancedFields.scss';

interface PaymentIconsProps {
  paymentCodes: string[];
}


const PaymentContainer: React.FC<PaymentIconsProps> = ({ paymentCodes }) => {
  const paymentMethodMap: { [key: string]: { icon: string; displayName: string } } = {
    'master card': { icon: mastercard, displayName: 'Mastercard' },
    'visa': { icon: visa, displayName: 'Visa' },
    'american express': { icon: amex, displayName: 'American Express' },
    'discover': { icon: discover, displayName: 'Discover' },
    'debit': { icon: debit, displayName: 'Debit' },
    'paypal': { icon: payPal, displayName: 'PayPal' },
    'venmo': { icon: venmo, displayName: 'Venmo' },
    'apple pay': { icon: applePay, displayName: 'Apple Pay' }
  };

  return (
    <>
      {paymentCodes.map((code) => {
        const normalizedCode = code.toLowerCase();
        const paymentMethod = paymentMethodMap[normalizedCode];
        if (paymentMethod) {
          return (
            <div key={code} className="payment-icon-wrapper">
              <Tippy content={paymentMethod.displayName} placement="top" theme="dnbtooltip">
                <img src={paymentMethod.icon} alt={paymentMethod.displayName} className="payment-icon" />
              </Tippy>
            </div>
          );
        }
        return null;
      })}
    </>
  );
};

export default PaymentContainer;
